"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Temperature = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11.5,3 C12.8807119,3 14,4.11928813 14,5.5 L14.0012562,12.7586157 C15.2065371,13.5659907 16,14.9403338 16,16.5 C16,18.9852814 13.9852814,21 11.5,21 C9.01471863,21 7,18.9852814 7,16.5 C7,14.9398199 7.79398577,13.5650852 8.99993511,12.757818 L9,5.5 C9,4.11928813 10.1192881,3 11.5,3 Z M11.5,4 C10.6715729,4 10,4.67157288 10,5.5 L9.99996673,13.3368314 C8.817511,13.8985702 8,15.1038151 8,16.5 C8,18.4329966 9.56700338,20 11.5,20 C13.4329966,20 15,18.4329966 15,16.5 C15,15.1042104 14.1829519,13.8992526 13.0010375,13.3373087 L13,5.5 C13,4.67157288 12.3284271,4 11.5,4 Z M12,7 L12.0004345,14.0500973 C13.1413382,14.2819003 14,15.2906746 14,16.5 C14,17.8807119 12.8807119,19 11.5,19 C10.1192881,19 9,17.8807119 9,16.5 C9,15.2903182 9.85916789,14.2813059 11.000574,14.0498926 L11,7 L12,7 Z" })));
};
Temperature.displayName = 'Temperature';
exports.default = Temperature;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Temperature.js.map